export const environment = {
    production: false,
    "basePath": "https://api.dev.safely.com/account",
    "portalConfig": {
        "customerPortalBaseUrl": "https://api.dev.safely.com/customerportal",
        "safelyAccountBaseUrl": "https://api.dev.safely.com/account",
        "adminPortalBaseUrl": "https://api.dev.safely.com/admin",
        legacyPortalAPIBasePath: 'https://legacy-api.dev.safely.com/api/internal/v1',
        "production": false,
        createReservationEnabled: true,
         checkinPortalBasePath: 'https://checkin.dev.safely.com'
    },
    msalConfig: {
        "auth": {
            "clientId": "6aa0aa7c-10cc-4ec7-85e2-da9ca2f880ed",
            "authority": "https://login.microsoftonline.com/b9c11c00-f76f-4e11-b244-68442b411785",
            "redirectUri": "https://admin.dev.safely.com",
            "postLogoutRedirectUri": "https://admin.dev.safely.com",
            "navigateToLoginRequestUrl": false,
            "validateAuthority": true
        },
        "cache": {
            "cacheLocation": "sessionStorage",
            "storeAuthStateInCookie": false
        },
        "guard": {
            "interactionType": "redirect",
            "authRequest": {
                "scopes": [
                    "openid",
                    "api://safely-portal-api-dev/Portal.Write"
                ]
            },
            loginFailedRoute: "/login-failed"
        },
        "interceptor": {
            "interactionType": "redirect",
            protectedResourceMap: [
                {
                    uri: "https://graph.microsoft.com/v1.0/me",

                    scopes: ["user.read"]
                },
                {
                    uri: "https://api.dev.safely.com/*",
                    scopes: ["api://safely-portal-api-dev/Portal.Write"]
                },
                {
                    uri: "https://legacy-api.dev.safely.com/*",
                    scopes: ["api://safely-portal-api-dev/Portal.Write"]
                },
                {
                    uri: "http://localhost:8080/*",
                    scopes: ["api://safely-portal-api-dev/Portal.Write"]
                }
            ]
        },
        graphApiConfig: {
            scopes: ['user.read'],
            uri: 'https://graph.microsoft.com/v1.0/me',
        },
    },
    "properties": {}
}